import { render, staticRenderFns } from "./WheelDetails.vue?vue&type=template&id=17d6779e&scoped=true"
import script from "./WheelDetails.vue?vue&type=script&lang=js"
export * from "./WheelDetails.vue?vue&type=script&lang=js"
import style0 from "./WheelDetails.vue?vue&type=style&index=0&id=17d6779e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d6779e",
  null
  
)

export default component.exports